import React, { CSSProperties } from "react";
import { getAvatarUrl } from "../../../utils/doctorAvatars";

interface DoctorCardExportProps {
  name?: string;
  specialty?: string;
  imageUrl?: string;
  description?: string;
  gender?: "M" | "F" | null;
  certificateNo?: string;
  backgroundColor?: string;
  textColor?: string;
  borderRadius?: number;
  showShadow?: boolean;
  imageSize?: "small" | "medium" | "large";
  layout?: "vertical" | "horizontal";
  /** Provider ID from API - used for syncing */
  providerId?: number | null;
  /** @deprecated - kept for backward compatibility */
  title?: string;
  textFontFamily?: string;
}

export const DoctorCardExport: React.FC<DoctorCardExportProps> = ({
  name = "Dr. Name",
  specialty = "Specialty",
  imageUrl = "",
  description,
  gender,
  certificateNo,
  backgroundColor = "#ffffff",
  textColor = "#1f2937",
  borderRadius = 12,
  showShadow = true,
  imageSize = "medium",
  layout = "vertical",
  textFontFamily,
}) => {
  const hasThai = (s: string) => /[\u0E00-\u0E7F]/.test(s);
  const ffStyle = (text?: string): CSSProperties => textFontFamily ? { fontFamily: `'${textFontFamily}', var(--font-family), sans-serif` } : (text && !hasThai(text)) ? { fontFamily: "var(--font-family-en, var(--font-family))" } : {};
  const imageSizeMap = { small: 80, medium: 120, large: 160 };
  const size = imageSizeMap[imageSize || "medium"];
  const isHorizontal = layout === "horizontal";

  const cardStyles: CSSProperties = {
    backgroundColor,
    borderRadius: `${borderRadius}px`,
    padding: "24px",
    boxShadow: showShadow ? "0 4px 6px -1px rgba(0, 0, 0, 0.1)" : "none",
    flex: "0 1 180px",
    minWidth: "100px",
    maxWidth: "220px",
    width: "180px",
    boxSizing: "border-box",
  };

  return (
    <div style={cardStyles} className="doctor-card" data-element="doctor-item" data-type="content">
      <div
        style={{
          display: isHorizontal ? "flex" : "block",
          textAlign: isHorizontal ? "left" : "center",
          alignItems: isHorizontal ? "center" : "initial",
          gap: isHorizontal ? "16px" : "0",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: isHorizontal ? "flex-start" : "center",
            marginBottom: isHorizontal ? "0" : "16px",
          }}
        >
          <img
            src={getAvatarUrl(imageUrl, gender)}
            alt={name}
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              width: size,
              height: size,
              flexShrink: 0,
            }}
          />
        </div>
        <div style={{ minWidth: 0, flex: isHorizontal ? 1 : "none" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: 600, color: textColor, margin: 0, ...ffStyle(name) }}>
            {name}
          </h3>
          <p style={{ color: "#6b7280", fontSize: "0.8rem", marginBottom: certificateNo || description ? "4px" : "8px", marginTop: 0, ...ffStyle(specialty) }}>
            {specialty}
          </p>
          {certificateNo && (
            <p style={{ color: "#9ca3af", fontSize: "0.75rem", marginBottom: description ? "4px" : "0", marginTop: 0 }}>
              {certificateNo}
            </p>
          )}
          {description && (
            <p style={{ color: textColor, opacity: 0.8, fontSize: "0.8rem", lineHeight: 1.5, margin: 0, ...ffStyle(description) }}>
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
